export default "__VITE_ASSET__Bmw91I27__"